import script from "./TextBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBlock.vue?vue&type=script&setup=true&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=05b65194&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b65194"]])

export default __exports__